import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useWindowSize } from "@reach/window-size";
import {
    Body,
    BodyContent,
    Wrapper,
    Overlay,
} from "./style";
import SideMenu from "../common/SideMenu";
import { HeaderToDisplay } from "./components/HeaderToDisplay";
import { SuccessAlertContext } from "../../context/SuccessAlertContext";
import SuccessAlert from "../common/alerts/SuccessAlert";
import { NetworkErrorAlertContext } from "../../context/NetworkErrorAlert";
import NetworkErrorAlert from "../common/alerts/NetworkErrorAlert";
import Loader from "../common/Loader";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import CopyAlert from "../common/alerts/CopyAlert";
import { CopyAlertContext } from "../../context/CopyAlertContext";
import { getMerchantBusinessDetails } from "../../utils/fetchMerchantBusDetails";
import { updateBusinessObj } from "../../pages/Settings/settingsSlice";
import { ErrorAlertContext } from "../../context/ErrorAlertContext";
import ErrorToastAlert from "../common/alerts/ErrorAlert";


type props = {
    children: React.ReactElement;
}

const AppShell = ({ children }: props) => {
    const { width } = useWindowSize();
    const dispatch = useAppDispatch();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const segments = location.pathname.split("/").filter((segment) => segment);
    const hasMoreThanOneSegment = segments.length > 2;
    const { business } = useAppSelector((state) => state.settings);
    const { userId, businessId } = useAppSelector((state) => state.users);

    const { showAlert, alertMessage } = useContext(
        SuccessAlertContext,
    );
    const { onShowAlert: onErrorAlert } = useContext(ErrorAlertContext);
    const { showAlert: copyAlert } = useContext(
        CopyAlertContext,
    );
    const {
        showAlert: showErrorAlert,
        alertMessage: errorAlertMessage,
    } = useContext(NetworkErrorAlertContext);
    const { status: userStatus } = useAppSelector(
        (state) => state.users,
    );
    const { pathname } = useLocation();
    
    const [isExpanded, setIsExpanded] = useState<
        "none" | "min" | "max"
    >(width > 992 ? "max" : "none");

    const onCollapse = () => {
        setIsExpanded("none");
    };

    const onShowSide = () => {
        setIsExpanded("max");
    };

    React.useEffect(() => {
        if (hasMoreThanOneSegment) {
            setIsExpanded('none');
        } else if (pathname && width <= 992) {
            setIsExpanded('none');
        } else {
            setIsExpanded('max');
        }
    }, [pathname, hasMoreThanOneSegment, width]);


    if (userStatus === "loading") {
        return <Loader isLoading isNotFull />;
    }

    useEffect(() => {
    if (!businessId) {
        getMerchantBusinessDetails(dispatch, userId, updateBusinessObj)
    }
    }, [business, userId])
    
    return (
        <Wrapper>
            <SideMenu
                onCollapse={onCollapse}
                isExpanded={isExpanded}
                dropdownOpen={dropdownOpen}
                setDropdownOpen={setDropdownOpen}
            />
            <Body $isExpanded={isExpanded}>
                {showErrorAlert && (
                    <NetworkErrorAlert
                        message={errorAlertMessage}
                    />
                )}
                {showAlert && (
                    <SuccessAlert message={alertMessage} />
                )}
                {onErrorAlert && (<ErrorToastAlert />)}
                {copyAlert && <CopyAlert />}

                <HeaderToDisplay 
                   onShowSide={onShowSide}
                   setDropdownOpen={setDropdownOpen}
                />
                <BodyContent>
                    <Outlet />
                    <div>{children}</div>
                </BodyContent>
            </Body>

            <Overlay
                onClick={() => setIsExpanded("none")}
                $isExpanded={isExpanded}
            />
        </Wrapper>
    );
};

export default AppShell;
